var _mask, _g, _mask2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmericanExpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 1,
    height: 2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 27h1v1H0v-1z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 27.5c0 .2-.3.4-.5.4s-.4-.2-.4-.4c0-.3.1-.5.4-.5s.4.2.4.5zm0 0c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5zm-.4-.1H.4h.2zm.1.3-.1-.1H.3v.1-.5h.1l.2.1v.4z",
    fill: "#0078a9"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 27,
    height: 28
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.6 0H28v27.9H1.6V0z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.8 0H1.6v11.7l.9-2.1h2l.2.5v-.5h2.2l.5 1.1.5-1.1h7.2c.3 0 .6 0 .8.2v-.2h2v.2c.3-.2.7-.2 1.2-.2h2.8l.3.5v-.5h2l.4.5v-.5h2V14h-2l-.5-.7v.7h-2.5l-.3-.7h-.6l-.3.7H19c-.5 0-.9-.1-1.2-.3v.3h-3.1v-1c0-.2 0-.2-.2-.2v1.2H8.2v-.6l-.2.6H6.8l-.3-.5v.5H4.1l-.3-.7h-.6l-.3.7H1.6V28h26.2v-8.4c-.3.2-.7.2-1 .2h-2v-.2l-1 .2h-6v-1l-.1-.2h-.1v1.2h-2v-1.2c-.3.2-.7.2-1 .2h-.3v1H12l-.5-.7-.7.7H6.8v-4.5h4l.6.7.6-.7h2.6c.3 0 .9 0 1 .3v-.3H18c.3 0 .7 0 1 .3v-.3h3.6v.3c.2-.2.6-.3 1-.3h2v.3c.2-.2.5-.3.9-.3h1.3V0zM3 12l.5-1.2L4 12H3zm12-.5-.3.1h-.9V11h1.3l.1.3-.1.3zm6.5.6-.5-1.3-.5 1.3h1zm-12-1.9H8.5l-1 2.2-1-2.2H5.4v3l-1.3-3H3l-1.4 3.3h.8l.3-.7h1.5l.3.7H6v-2.6l1.1 2.6h.6l1.1-2.6v2.6h.8v-3.3zm3 2.6H11v-.7h1.6v-.6H11v-.6h1.7v-.7H10v3.3h2.5v-.7zm3.2-2.4c-.3-.2-.5-.2-1-.2h-1.6v3.3h.7v-1.2h.8l.6.1v1.1h.8v-.7l-.1-.6a1 1 0 0 0-.4-.2 1 1 0 0 0 .6-.9c0-.4-.2-.6-.4-.7zm.8 3h.7v-3.2h-.7v3.3zm9.5 0h-1.1L23.5 11v2.5H22l-.3-.7h-1.5l-.3.7h-.8c-.4 0-.9-.1-1.1-.4-.3-.3-.4-.6-.4-1.2 0-.5 0-1 .4-1.3.2-.3.6-.4 1.1-.4h.7v.7h-.7c-.2 0-.4 0-.6.2l-.1.7.1.8.6.2h.3l1-2.6h1.1l1.3 3v-3h1.1l1.3 2.3v-2.3h.8v3.3zm-16 5H8.2v-.6h1.6V17H8.2v-.6h1.9l.8 1-.9 1zm1.8-1 1.2-1.2v2.6l-1.2-1.3zm2.9 0h-1v-.9h1c.2 0 .4.1.4.4a.4.4 0 0 1-.4.4zm3.5-.2H17v-.7h1.3l.2.3a.4.4 0 0 1-.2.4zm-3.5-1.4h-2.4l-1 1.1-.8-1h-3V19h3l.9-1 .9 1h1.4V18h1c.5 0 1.2-.2 1.2-1.1 0-.9-.7-1-1.2-1zm4.1.2-.9-.2h-1.7v3.3h.8v-1.2h.8l.5.1.1.7v.4h.8v-.6l-.1-.6a.8.8 0 0 0-.4-.3c.2-.1.5-.4.5-.9 0-.4-.1-.6-.4-.7zm3.3 2.4h-1.8v-.6H22V17h-1.7v-.6h1.8v-.7h-2.5v3.3h2.5v-.7zm2.8-1c-.2-.2-.4-.3-.9-.3H23.4l-.2-.3.1-.2H25v-.8h-1.5c-.8 0-1 .5-1 1 0 1 .8 1 1.5 1h.2l.1.3v.2h-1.8v.8H24c.7 0 1.1-.3 1.1-1 0-.4 0-.6-.2-.7zm3.1.7c0 .7-.4 1-1.2 1h-1.4v-.7h1.7a.3.3 0 0 0 .1-.3V18h-.3c-.7-.1-1.6 0-1.6-1.1 0-.5.3-1 1-1h1.5v.7h-1.6a.3.3 0 0 0-.1.3l.1.3h.7c.4 0 .7.1.9.3.1.1.2.3.2.7z",
    fill: "#0078a9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american-express.dca80cb571b881bb0d094a8b80a50e4a.svg";
export { ForwardRef as ReactComponent };